import { API } from "../APIs/index";
import { Pagination, Tokens } from "../Interfaces/Interfaces";
import { TokenValidator } from "./TokenValidator";

export class DashboardService {
  tokens: any | Tokens;
  get = API.aggregator + "get/";
  transaction = API.transactions + "get/";
  getCustomer = API.customer + "get/";
  getNewDashboard = API.newDashboard;
  TransactionDashboard = API.transactionDashboard + "get/";
  constructor() {
    this.tokens = TokenValidator();
  }

  async getAgentDashboard() {
    try {
      let response = await fetch(
        this.TransactionDashboard + `dashboard/getagentmetrics`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getAgentActivityDashboardServices(data: any) {
    try {
      let response = await fetch(
        this.TransactionDashboard + `Dashboard/getagentactivitymetric/${data}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getAchievementDashboardServices(data: any) {
    try {
      let response = await fetch(
        this.TransactionDashboard +
          `Dashboard/gettransactiontargetperformance/${data}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async AggregatorCountDashboardService(data: any) {
    try {
      let response = await fetch(this.get + `aggregator/dashboard`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getEarningDashboard(whereCondition: any) {
    try {
      let response = await fetch(
        this.get + `earning/dashboard/${whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAggregatorEarningDashboard(whereCondition: any) {
    try {
      let response = await fetch(
        this.get + `earning/dashboard/${whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAgentComissionEarningDashboard(whereCondition: any) {
    try {
      let response = await fetch(
        this.get + `earning/dashboard/${whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  
  async getTransactionAgentByIdService(agentId: any, whereCondition: any) {
    try {
      let response = await fetch(
        this.transaction +
          `transactiontarget/getbyagent/${agentId}/${whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getCustomersAgentByIdService(agentId: any, whereCondition: any) {
    try {
      let response = await fetch(
        this.getCustomer + `Dashboard/${agentId}/${whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getTransactionsAgentByIdService(agentId: any, whereCondition: any) {
    try {
      let response = await fetch(
        this.transaction +
          `transaction/TradePartner/AgentDashboard/${agentId}/${whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getTransactionDashboard(data: any) {
    try {
      let response = await fetch(
        this.get + `transaction/dashboard/${data.id}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getTransactionCountDashboardSummray() {
    try {
      let response = await fetch(
        this.getNewDashboard + `dashboard/gettransactionsummary`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getPerformanceMetricsAndCommissionService(data: any) {
    try {
      let response = await fetch(
        this.TransactionDashboard +
          `AggregatorDashboard/getperformancemetrics/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAgentPerformanceDashboardService(data: Pagination) {
    if (data.page !== undefined) {
      try {
        let response = await fetch(
          this.TransactionDashboard +
            `AggregatorDashboard/getagentrankingmetrics/${data.id}/${data.page}/${data.pageSize}/${data.whereCondition}`,
            // `AggregatorDashboard/getagentrankingmetrics/${1}/${100}/${data.whereCondition}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.tokens.access_token}`,
              "x-api-key": `${process.env.REACT_APP_API_KEY}`,
            },
          }
        );
  
        return await response.json();
      } catch (err) {
        throw err;
      }
    }
  }

  async getAggregatorPerformanceDashboardService(data: Pagination) {
    if (data.page !== undefined) {
      try {
        let response = await fetch(
          this.TransactionDashboard +
            `AggregatorDashboard/getaggregatorrankingmetrics/${data.id}/${data.page}/${data.pageSize}/${
              data.whereCondition
            }`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.tokens.access_token}`,
              "x-api-key": `${process.env.REACT_APP_API_KEY}`,
            },
          }
        );
  
        return await response.json();
      } catch (err) {
        throw err;
      }
    }
  }

  async getPosMetricsDashboardService() {
    try {
      let response = await fetch(
        this.TransactionDashboard + `AggregatorDashboard/getposmetrics`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getFloatDashboardService() {
    try {
      let response = await fetch(
        this.TransactionDashboard + `AggregatorDashboard/getfloatbalance`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getEarningCommissionDashboardService(data: any) {
    try {
      let response = await fetch(
        this.TransactionDashboard + `AggregatorDashboard/getcommission/${data}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getBottomAgentService(data: any) {
    try {
      let response = await fetch(
        this.TransactionDashboard +
          `Dashboard/getagenttargetperformance/${data}/${"1"}/${10}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getAnalyticsDashboardService() {
    try {
      let response = await fetch(
        this.TransactionDashboard + `Dashboard/getanalyticalupdate`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async getcoordinatordashboard() {
    try {
      let response = await fetch(
        this.transaction + `transaction/getcoordinatordashboard`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
}
